const actions = {
  GET_VENDOR: "GET_VENDOR",
  GET_VENDOR_SUCCESS: "GET_VENDOR_SUCCESS",
  GET_VENDOR_FAILED: "GET_VENDOR_FAILED",

  RESET_MESSAGE: 'RESET_MESSAGE',

  GET_ACODE: "GET_ACODE",
  GET_ACODE_SUCCESS: "GET_ACODE_SUCCESS",
  GET_ACODE_FAILED: "GET_ACODE_FAILED",

  PRINT_DETAILS: "PRINT_DETAILS",
  PRINT_DETAILS_SUCCESS: "PRINT_DETAILS_SUCCESS",
  PRINT_DETAILS_FAILED: "PRINT_DETAILS_FAILED",


  GET_PLAN: "GET_PLAN",
  GET_PLAN_SUCCESS: "GET_PLAN_SUCCESS",
  GET_PLAN_FAILED: "GET_PLAN_FAILED",

  GET_BILLING_CODE: "GET_BILLING_CODE",
  GET_BILLING_CODE_SUCCESS: "GET_BILLING_CODE_SUCCESS",
  GET_BILLING_CODE_FAILED: "GET_BILLING_CODE_FAILED",

  GET_DASHBOARD: "GET_DASHBOARD",
  GET_DASHBOARD_SUCCESS: "GET_DASHBOARD_SUCCESS",
  GET_DASHBOARD_FAILED: "GET_DASHBOARD_FAILED",

  GET_USER_PANEL_ACCESS: "GET_USER_PANEL_ACCESS",
  GET_USER_PANEL_ACCESS_SUCCESS: "GET_USER_PANEL_ACCESS_SUCCESS",
  GET_USER_PANEL_ACCESS_FAILED: "GET_USER_PANEL_ACCESS_FAILED",

  getVendor: () => ({
    type: actions.GET_VENDOR,
  }),
  getVendorSuccess: (data) => ({
    type: actions.GET_VENDOR_SUCCESS,
    data,
  }),
  getVendorError: (error) => ({
    type: actions.GET_VENDOR_FAILED,
    error,
  }),

  getACode: () => ({
    type: actions.GET_ACODE,
  }),
  getACodeSuccess: (data) => ({
    type: actions.GET_ACODE_SUCCESS,
    data,
  }),
  getACodeError: (error) => ({
    type: actions.GET_ACODE_FAILED,
    error,
  }),

  printDetail: (data) => ({
    type: actions.PRINT_DETAILS,
    payload: { data },
  }),

  printDetailSuccess: (data) => ({
    type: actions.PRINT_DETAILS_SUCCESS,
    data,
  }),

  printDetailError: (error) => ({
    type: actions.PRINT_DETAILS_FAILED,
    error,
  }),


  getPlan: (data) => ({
    type: actions.GET_PLAN,
    payload: { data },
  }),
  getPlanSuccess: (result) => ({
    type: actions.GET_PLAN_SUCCESS,
    result
  }),
  getPlanError: (error) => ({
    type: actions.GET_PLAN_FAILED,
    error
  }),

  getBillingCode: (data) => ({
    type: actions.GET_BILLING_CODE,
    payload: { data },
  }),
  getBillingCodeSuccess: (result) => ({
    type: actions.GET_BILLING_CODE_SUCCESS,
    result
  }),
  getBillingCodeError: (error) => ({
    type: actions.GET_BILLING_CODE_FAILED,
    error
  }),

  getDashboardData: (data) => ({
    type: actions.GET_DASHBOARD,
    payload: { data },
  }),
  getDashboardDataSuccess: (result) => ({
    type: actions.GET_DASHBOARD_SUCCESS,
    result
  }),
  getDashboardDataError: (error) => ({
    type: actions.GET_DASHBOARD_FAILED,
    error
  }),

  getUserPanelAccess: (data) => ({
    type: actions.GET_USER_PANEL_ACCESS,
    payload: { data },
  }),

  getUserPanelAccessSuccess: (data) => ({
    type: actions.GET_USER_PANEL_ACCESS_SUCCESS,
    payload: { data },
  }),

  getUserPanelAccessError: (error) => ({
    type: actions.GET_USER_PANEL_ACCESS_FAILED,
    error,
  }),

  resetMessage: () => ({
    type: actions.RESET_MESSAGE,
  }),


};
export default actions;
